// extracted by mini-css-extract-plugin
export default {"Container":"ShadowBox_Container__t7N0Y"};